// src/components/Admin/AdminImagesField.jsx
// Selector de fotos (productos y cuartos): muestra las actuales y las nuevas,
// con botón para quitar; la primera es la portada. El estado vive en el padre.
import React, { useEffect, useMemo } from 'react';

const ImageThumb = ({ src, isCover, isNew, onRemove }) => (
  <div className="relative w-24 h-24">
    <img src={src} alt="" className="w-full h-full rounded-xl object-cover border border-[#3A2A20]/10" />
    {isCover && (
      <span className="absolute bottom-1 left-1 px-1.5 py-0.5 text-[10px] font-semibold rounded bg-[#9A0002] text-[#EFE6DD]">
        Portada
      </span>
    )}
    {isNew && (
      <span className="absolute top-1 left-1 px-1.5 py-0.5 text-[10px] font-semibold rounded bg-white/90 text-[#3A2A20]">
        Nueva
      </span>
    )}
    <button
      type="button"
      onClick={onRemove}
      aria-label="Quitar imagen"
      className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#3A2A20] text-white text-sm leading-none shadow hover:bg-[#9A0002] transition"
    >
      ×
    </button>
  </div>
);

// keptImages: URLs actuales que se conservan · newImages: File[] por subir
const AdminImagesField = ({ keptImages, setKeptImages, newImages, setNewImages, max, onError, labelClass }) => {
  const slotsLeft = max - keptImages.length - newImages.length;

  const handleAdd = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > slotsLeft) onError?.(`Máximo ${max} imágenes`);
    setNewImages((prev) => [...prev, ...files.slice(0, Math.max(slotsLeft, 0))]);
    e.target.value = ''; // permite volver a elegir el mismo archivo
  };

  // Vistas previas de los archivos nuevos (se liberan al cambiar)
  const newPreviews = useMemo(() => newImages.map((file) => URL.createObjectURL(file)), [newImages]);
  useEffect(() => () => newPreviews.forEach((url) => URL.revokeObjectURL(url)), [newPreviews]);

  return (
    <div>
      <label className={labelClass}>
        Imágenes ({keptImages.length + newImages.length}/{max}) · la primera es la portada
      </label>
      <div className="flex flex-wrap gap-3">
        {keptImages.map((url, i) => (
          <ImageThumb
            key={url}
            src={url}
            isCover={i === 0}
            onRemove={() => setKeptImages((prev) => prev.filter((u) => u !== url))}
          />
        ))}
        {newPreviews.map((url, i) => (
          <ImageThumb
            key={url}
            src={url}
            isNew
            isCover={keptImages.length === 0 && i === 0}
            onRemove={() => setNewImages((prev) => prev.filter((_, j) => j !== i))}
          />
        ))}
        {slotsLeft > 0 && (
          <label className="w-24 h-24 rounded-xl border-2 border-dashed border-[#3A2A20]/20 flex flex-col items-center justify-center text-[#3A2A20]/50 text-xs cursor-pointer hover:border-[#9A0002]/40 hover:text-[#9A0002] transition">
            <span className="text-2xl leading-none">+</span>
            Agregar
            <input type="file" accept="image/png,image/jpeg" multiple onChange={handleAdd} className="sr-only" />
          </label>
        )}
      </div>
    </div>
  );
};

export default AdminImagesField;
